var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"svg-path svg-path--discover",style:({
    '--c': _vm.props.color,
})},[_c('g',[_c('path',{attrs:{"d":_vm.props.path}})])])}
var staticRenderFns = []

export { render, staticRenderFns }